module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAElBMVEUAAABMhf9MhP9MhP9MhP8AAADZFUbdAAAABHRSTlMAq+THWay14AAAAAFiS0dEAIgFHUgAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAAHdElNRQfjCw4LCALhiYFrAAAALUlEQVQoz2NgoAUQRAMMLmgAU0AJDdDEXQzGaIAIh2FooQnA8D5hh2EEMi0AAKh4JkG0vYiKAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE5LTExLTE0VDExOjA4OjAyKzAwOjAw8dFI+wAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxOS0xMS0xNFQxMTowODowMiswMDowMICM8EcAAAAZdEVYdFNvZnR3YXJlAHd3dy5pbmtzY2FwZS5vcmeb7jwaAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/Assets/img/iconmenu.png
// module id = 986
// module chunks = 0